<dva-loading-indicator></dva-loading-indicator>
<dva-backdrop #backdrop="dvaBackdrop"></dva-backdrop>

<div class="container" fxLayout="column">
  <ng-container *ngIf="(toolbarPosition$ | async) === 'above-fixed'">
    <ng-container *ngTemplateOutlet="toolbar"></ng-container>
  </ng-container>

  <mat-sidenav-container autosize fxFlex>
    <!-- SIDENAV -->
    <mat-sidenav
      (closedStart)="closeSidenav()"
      (openedStart)="openSidenav()"
      [mode]="sidenavMode$ | async"
      [opened]="sidenavOpen$ | async"
      *ngIf="sideNavigation$ | async"
      class="dva-collapsable-sidenav"
    >
      <dva-sidenav [collapsed]="sidenavCollapsed$ | async" [expanded]="sidenavExpanded$ | async"></dva-sidenav>
    </mat-sidenav>
    <!-- END SIDENAV -->

    <mat-sidenav [(opened)]="progressPanelOpen" mode="over" position="end">
      <dva-progress-panel></dva-progress-panel>
    </mat-sidenav>

    <mat-sidenav-content class="content-container" fxLayout="column">
      <ng-container *ngIf="(toolbarPosition$ | async) === 'fixed'">
        <ng-container *ngTemplateOutlet="toolbar"></ng-container>
      </ng-container>

      <!-- CONTENT -->
      <div
        [class.scroll-disabled]="scrollDisabled$ | async"
        cdkScrollable
        class="content"
        fxFlex="auto"
        fxLayout="column"
      >
        <ng-container *ngIf="(toolbarPosition$ | async) === 'static'">
          <ng-container *ngTemplateOutlet="toolbar"></ng-container>
        </ng-container>

        <div class="content-inner" fxFlex="auto">
          <router-outlet></router-outlet>
        </div>

        <ng-container *ngIf="(footerPosition$ | async) === 'static'">
          <ng-container *ngTemplateOutlet="footer"></ng-container>
        </ng-container>
      </div>
      <!-- END CONTENT -->

      <ng-container *ngIf="(footerPosition$ | async) === 'fixed'">
        <ng-container *ngTemplateOutlet="footer"></ng-container>
      </ng-container>
    </mat-sidenav-content>
  </mat-sidenav-container>

  <ng-container *ngIf="(footerPosition$ | async) === 'above-fixed'">
    <ng-container *ngTemplateOutlet="footer"></ng-container>
  </ng-container>
</div>

<ng-template #toolbar>
  <!-- TOOLBAR -->
  <dva-toolbar
    (openProgressPanel)="openProgressPanel()"
    [hasNavigation]="topNavigation$ | async"
    (openSidenav)="openSidenav()"
    *ngIf="toolbarVisible$ | async"
    fxFlex="none"
  ></dva-toolbar>
  <!-- END TOOLBAR -->

  <!-- NAVIGATION -->
  <dva-navigation fxFlex="none"></dva-navigation>
  <!-- END NAVIGATION -->
</ng-template>

<ng-template #footer>
  <!-- FOOTER -->
  <dva-footer fxFlex="none"></dva-footer>
  <!-- END FOOTER -->
</ng-template>
